import type { CalendarStripItem, CardDto, Destination, EnvelopeResponse } from '@konvert/shared';
import { formatDateWithWeekdayRu } from '@konvert/domain';
import { CalendarStrip, Drawers } from '../components/Droppables.js';
import { CardTile } from '../components/CardTile.js';
import { t } from '../lib/i18n.js';

export function IndexScreen({
  strip,
  today,
  opened,
  openedLabel,
  threshold,
  onPickDay,
  onOpenDrawer,
  onOpenCard,
}: {
  strip: CalendarStripItem[];
  today: string;
  opened: EnvelopeResponse | null;
  openedLabel: string;
  threshold: number;
  onPickDay: (date: string) => void;
  onOpenDrawer: (destination: Destination) => void;
  onOpenCard: (card: CardDto) => void;
}): JSX.Element {
  return (
    <div className="space-y-4">
      <section>
        <h2 className="mb-2 text-xs uppercase tracking-wide text-ink-soft">{t('index.days')}</h2>
        <CalendarStrip items={strip} today={today} onPick={onPickDay} />
      </section>

      <section>
        <h2 className="mb-2 text-xs uppercase tracking-wide text-ink-soft">{t('index.drawers')}</h2>
        <Drawers today={today} onOpen={onOpenDrawer} />
      </section>

      {opened ? (
        <section className="envelope p-4">
          <h2 className="mb-3 text-base text-ink">
            {openedLabel}
            {opened.period_start ? (
              <span className="ml-2 font-hand text-lg text-ink-soft">
                {formatDateWithWeekdayRu(opened.period_start)}
              </span>
            ) : null}
          </h2>
          <div className="space-y-2">
            {opened.cards.length === 0 ? (
              <p className="py-4 text-center text-sm text-ink-soft">Пусто.</p>
            ) : (
              opened.cards.map((card) => (
                <CardTile key={card.id} card={card} onOpen={onOpenCard} threshold={threshold} />
              ))
            )}
          </div>
        </section>
      ) : null}
    </div>
  );
}
